export const EVENTS_ROUTER_ROOT = '/events';
export const EVENTS_ROUTER_NEW = EVENTS_ROUTER_ROOT + '/new';
export const EVENTS_ROUTER_EDIT = EVENTS_ROUTER_ROOT + '/edit/:id';



// WEBPACK FOOTER //
// ./src/components/Events/constants.js